import { KeyPair } from 'jwt-cert-sdk';

import { UseNativeObjectStoreOptions, useNativeObjectStore } from './useNativeObjectStore';

export function useKeyPair(opts: UseNativeObjectStoreOptions<KeyPair>) {
  const provideKey = useNativeObjectStore('keypairs', async () => await KeyPair.generate_new());

  return provideKey(opts);
}
